/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdTeacherDataMutationRequest,
  PutApiV1PersonIdTeacherDataMutationResponse,
  PutApiV1PersonIdTeacherDataPathParams,
  PutApiV1PersonIdTeacherData400,
  PutApiV1PersonIdTeacherData401,
  PutApiV1PersonIdTeacherData404,
  PutApiV1PersonIdTeacherData500,
} from "../../types/personTeacherController/PutApiV1PersonIdTeacherData.ts";

function getPutApiV1PersonIdTeacherDataUrl(
  id: PutApiV1PersonIdTeacherDataPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/person/${id}/teacher-data` as const,
  };
  return res;
}

/**
 * @description Atualiza a aba Teacher. Cria TeachingStaff caso ainda não exista. Regras legado preservadas: LattesUpdateDate só é gravada quando IsLattes=true; OtherBusinessSector só é preservada quando BusinessSectorId=40. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de docente (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/teacher-data}
 */
export async function putApiV1PersonIdTeacherData(
  id: PutApiV1PersonIdTeacherDataPathParams["id"],
  data?: PutApiV1PersonIdTeacherDataMutationRequest,
  config: Partial<RequestConfig<PutApiV1PersonIdTeacherDataMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdTeacherDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdTeacherData400
      | PutApiV1PersonIdTeacherData401
      | PutApiV1PersonIdTeacherData404
      | PutApiV1PersonIdTeacherData500
    >,
    PutApiV1PersonIdTeacherDataMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdTeacherDataUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
